class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.inputClass = 'js-date';
        this.outputClass = 'js-countdown';
        this.endDate = null;
        this.countdownTimer = null;
    }

    connectedCallback() {
        this.inputEl = this.querySelector(`.${this.inputClass}`);
        this.outputEl = this.querySelector(`.${this.outputClass}`);

        if (!this.inputEl || !this.outputEl) return;

        this.inputEl.addEventListener('change', this.start.bind(this));

        if (this.inputEl.value) {
            this.endDate = new Date(this.inputEl.value).getTime();
            this.start();
        }
    }

    start() {
        const selectedDate = this.inputEl.value;

        if (!selectedDate) {
            this.showMessage('Please select a valid date.');
            return;
        }

        this.endDate = new Date(selectedDate).getTime();

        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }

        this.updateCountdown();
        this.countdownTimer = setInterval(() => {
            this.updateCountdown();
        }, 1000);
    }

    updateCountdown() {
        const now = Date.now();
        const distance = this.endDate - now;

        if (distance <= 0) {
            clearInterval(this.countdownTimer);
            this.showMessage('Time out!');
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.outputEl.innerHTML = `
      <span class="info-time"><span class="time">${days}</span><span class="info">days</span></span>
      <span class="info-time"><span class="time">${hours}</span><span class="info">hours</span></span>
      <span class="info-time"><span class="time">${minutes}</span><span class="info">minutes</span></span>
      <span class="info-time"><span class="time">${seconds}</span><span class="info">seconds</span></span>
    `;
    }

    showMessage(message) {
        if (this.outputEl) {
            this.outputEl.textContent = message;
        }
    }
}

customElements.define('countdown-timer', CountdownTimer);